import styled from "styled-components"

const Button = styled.button`
  padding: 0.875rem;
  border: none;
  border-radius: 0.5rem;
  background: #25beae;
  color: #000;
  text-transform: uppercase;
  font-family: "din-condensed";
  text-transform: uppercase;
  font-size: 32px;

  & + & {
    margin-left: 1rem;
  }
`

export default Button



// WEBPACK FOOTER //
// ./src/Kiosk/Shared/Button.js